@let route = $route();
@let expanded = $expanded();
@let itemExpanded = $itemExpanded();
@let activeChild = $hasActiveChild();

@if (expanded) {

    <button
        type="button"
        class="inline-nav-row inline-nav-group-parent"
        [class.inline-nav-group-parent-has-active]="activeChild"
        [attr.aria-expanded]="itemExpanded"
        [attr.aria-controls]="$childrenId()"
        (click)="onToggleInline()">
        <span class="inline-nav-row-icon">
            @if (route.data?.icon) { <i class="fa" [ngClass]="route.data.icon"></i> }
        </span>
        <span class="inline-nav-row-label">{{ route.data?.title }}</span>
        <i class="inline-nav-group-chevron fa-regular" [class.fa-chevron-down]="itemExpanded" [class.fa-chevron-right]="!itemExpanded"></i>
    </button>

    @if (itemExpanded) {

        <div class="inline-nav-group-children" [id]="$childrenId()" role="group">
            @for (child of route.children; track child.path) {
                @if (!child.data?.hidden) {
                    <a
                        class="inline-nav-row inline-nav-group-child"
                        routerLink="/{{ route.path }}/{{ child.path }}"
                        routerLinkActive="active">
                        <span class="inline-nav-row-icon">
                            @if (child.data?.icon) { <i class="fa" [ngClass]="child.data.icon"></i> }
                        </span>
                        <span class="inline-nav-row-label">{{ child.data?.title }}</span>
                    </a>
                }
            }
        </div>
    }

} @else {

    <a
        class="inline-nav-row inline-nav-rail-flyout-trigger"
        [class.active]="activeChild"
        [class.flyout-open]="$flyoutOpen()"
        cdkOverlayOrigin
        #flyoutTrigger="cdkOverlayOrigin"
        aria-haspopup="menu"
        [attr.aria-expanded]="$flyoutOpen()"
        [attr.aria-controls]="$childrenId()"
        [attr.aria-label]="route.data?.title"
        [title]="$safeNavigationMigration(route.data?.title)"
        routerLink="/{{ route.path }}"
        (mouseenter)="onTriggerEnter()"
        (mouseleave)="onTriggerLeave()">

        <span class="inline-nav-row-icon">
            @if (route.data?.icon) { <i class="fa" [ngClass]="route.data.icon"></i> }
        </span>
        <span class="inline-nav-row-label">{{ route.data?.title }}</span>
        <i class="inline-nav-rail-flyout-chevron fa-regular fa-chevron-right" aria-hidden="true"></i>

    </a>

    <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="flyoutTrigger"
        [cdkConnectedOverlayOpen]="$flyoutOpen()"
        [cdkConnectedOverlayPositions]="flyoutPositions">

        <div class="inline-nav-flyout" [id]="$childrenId()" role="group" (mouseenter)="onFlyoutEnter()" (mouseleave)="onFlyoutLeave()">
            <div class="inline-nav-flyout-title">{{ route.data?.title }}</div>
            @for (child of route.children; track child.path) {
                @if (!child.data?.hidden) {
                    <a
                        class="inline-nav-flyout-row"
                        routerLink="/{{ route.path }}/{{ child.path }}"
                        routerLinkActive="active"
                        (click)="onChildClick()">
                        <span class="inline-nav-row-icon">
                            @if (child.data?.icon) { <i class="fa" [ngClass]="child.data.icon"></i> }
                        </span>
                        <span class="inline-nav-row-label">{{ child.data?.title }}</span>
                    </a>
                }
            }
        </div>

    </ng-template>
}
